import {Box, Theme} from "@mui/material";
import {JSX} from "react";
import {SxProps} from "@mui/system/styleFunctionSx";

export interface FullSizeBoxProps {
    readonly children?: JSX.Element | JSX.Element[];
    readonly centerVertically?: boolean;

    readonly sx?: SxProps<Theme>
}

export default function FullSizeBox(props: FullSizeBoxProps) {

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ...(props.centerVertically && {
                    justifyContent: 'center',
                }),

                ...props.sx,
            }}
        >
            {props.children}
        </Box>
    )
}